import DelayRangeFilter from 'components/Billing/DelayRangeFilter';
import { buildAlertIdOverride } from 'components/Billing/alertAction';
import SummaryCards from 'components/Billing/SummaryCards';
import { buildBillingColumns } from 'components/Billing/columns';
import { buildHistoryOverride } from 'components/Billing/historyAction';
import { buildRenegotiationOverride } from 'components/Billing/renegotiationTag';
import BasicTable from 'components/Form/Table';
import TableWrapper from 'components/TableWrapper';
import ContainerAuthenticated from 'containers/Authenticated';
import { CoreContext } from 'context/CoreContext';
import useBillingList from 'hooks/useBillingList';
import { useContext, useMemo } from 'react';
import { BILLING_QUERIES, buildCards } from 'utils/billing';

// Degrau judicial. E o unico recortado por STATUS, e nao por atraso: o
// contrato esta aqui porque alguem o encaminhou, e continua aqui por quantos
// dias de atraso venha a acumular. Por isso o filtro de/ate do cabecalho
// refina o que ja chegou, mas nao e o que define a tela.
export default function BillingExecucao() {
  const { user, setModal } = useContext(CoreContext);
  const {
    loading,
    visibleRows,
    indicators,
    delayFrom,
    setDelayFrom,
    delayTo,
    setDelayTo,
    clearDelay,
    criticalOnly,
    toggleCritical,
    reload,
  } = useBillingList({ query: BILLING_QUERIES.execucao });

  const columns = useMemo(
    () =>
      buildBillingColumns(
        // Mesmas colunas da Cobranca.
        [
          'id',
          'contrato',
          'data_emissao',
          'banco',
          'distributor',
          'integrator',
          'customer',
          'telefone',
          'parcela',
          'valor_parcelas',
          'data_vencimento',
          'dias_atraso',
          'ultima_tentativa',
          'historico',
        ],
        {
          user,
          overrides: {
            ...buildAlertIdOverride({ setModal, reload }),
            ...buildRenegotiationOverride(),
            ...buildHistoryOverride({ setModal, reload }),
          },
        }
      ),
    [user, setModal, reload]
  );

  const cards = buildCards(indicators, {
    onToggleCritical: toggleCritical,
    criticalActive: criticalOnly,
  });

  return (
    <ContainerAuthenticated>
      <TableWrapper
        title="Execução"
        search
        filters={
          <DelayRangeFilter
            from={delayFrom}
            to={delayTo}
            onChangeFrom={setDelayFrom}
            onChangeTo={setDelayTo}
            onClear={clearDelay}
          />
        }
      >
        <SummaryCards cards={cards} />
        <BasicTable
          loading={loading}
          columns={columns}
          rows={visibleRows}
          groupBy="id"
          pagination
        />
      </TableWrapper>
    </ContainerAuthenticated>
  );
}
